var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"venue-introduce2"},[_c('venue-intro-swiper',{staticClass:"left-swiper",attrs:{"data":_vm.data.images}}),_c('venue-intro-text',{staticClass:"right-text",attrs:{"data":_vm.data.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }